import { render } from "./PatientDetalisOverlay.vue?vue&type=template&id=6197c058&scoped=true&lang=pug"
import script from "./PatientDetalisOverlay.vue?vue&type=script&lang=js"
export * from "./PatientDetalisOverlay.vue?vue&type=script&lang=js"

import "./PatientDetalisOverlay.vue?vue&type=style&index=0&id=6197c058&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6197c058"]])

export default __exports__